import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["catalogSelect", "catalogCheckbox", "bulkAction"]

    assignAll(event) {
        event.preventDefault()
        this.updateMatchingCheckboxes(true)
    }

    removeAll(event) {
        event.preventDefault()
        this.updateMatchingCheckboxes(false)
    }

    updateMatchingCheckboxes(checked) {
        const catalogId = this.catalogSelectTarget.value
        if (!catalogId) {
            window.alert("Select a catalog first")
            return
        }

        this.catalogCheckboxTargets.forEach((checkbox) => {
            if (checkbox.dataset.catalogId === catalogId) {
                checkbox.checked = checked
            }
        })
    }

    assignAllFiltered(event) {
        event.preventDefault()
        this.submitBulkAction("assign")
    }

    removeAllFiltered(event) {
        event.preventDefault()
        this.submitBulkAction("remove")
    }

    submitBulkAction(action) {
        const catalogId = this.catalogSelectTarget.value
        if (!catalogId) {
            window.alert("Select a catalog first")
            return
        }

        this.bulkActionTarget.value = action
        this.element.querySelector("#catalog-items-matrix-form").requestSubmit()
    }
}
